module.exports = __webpack_public_path__ + "static/media/3360.8e9a5d56.jpg";